import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

export default new Router({
  mode: "history",
  base: "/appindex/",
  routes: [
    {
      path: "/",
      name: "index2",
      component: () => import("@/pages/index2"),
      meta:{title:'首页',keepAlive:false}
    },
    {
      path: "/my",
      name: "my",
      component: () => import("@/pages/my"),
      meta:{title:'我的主页',keepAlive:false}
    },
    {
      path: "/emailModify",
      name: "emailModify",
      component: () => import("@/pages/emailModify"),
      meta:{title:'重置邮箱密码',keepAlive:false}
    },
    {
      path: "/uploadmore",
      name: "uploadmore",
      component: () => import("@/components/uploadmore"),
      meta:{title:'上传更多',keepAlive:false}
    },
    {
      path: "/modifyMy",
      name: "modifyMy",
      component: () => import("@/pages/modifyMy"),
      meta:{title:'修改信息',keepAlive:true}
    },
    {
      path: "/moreApps",
      name: "moreApps",
      component: () => import("@/pages/moreApps"),
      meta:{title:'更多应用',keepAlive:false}
    },
    {
      path: "/search",
      name: "search",
      component: () => import("@/pages/search"),
      meta:{title:'搜索',keepAlive:false}
    },
    {
      path: "/myAsset",
      name: "myAsset",
      component: () => import("@/pages/myAsset"),
      meta:{title:'我的资产',keepAlive:true}
    },
    {
      path: "/cache",
      name: "cache",
      component: () => import("@/pages/cache"),
      meta:{title:'清除缓存',keepAlive:false}
    },
    {
      path: "/more",
      name: "more",
      component: () => import("@/pages/more"),
      meta:{title:'更多应用',keepAlive:true}
    },
    {
      path: "/feedBack",
      name: "feedBack",
      component: () => import("@/pages/feedBack"),
      meta:{title:'反馈',keepAlive:false}
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js